import { ReactNode } from 'react';
import { 
    AfghanistanFlagIcon, 
    AlandIslandsFlagIcon, 
    AlbaniaFlagIcon, 
    AndorraFlagIcon, 
    AngolaFlagIcon, 
    AnguillaFlagIcon, 
    AntiguaAndBarbudaFlagIcon, 
    ArgentinaFlagIcon, 
    ArmeniaFlagIcon,
    ArubaFlagIcon,
    AustraliaFlagIcon, 
    AustriaFlagIcon, 
    AzerbaijanFlagIcon, 
    BahamasFlagIcon, 
    BahrainFlagIcon, 
    BangladeshFlagIcon, 
    BarbadosFlagIcon, 
    BelarusFlagIcon, 
    BelgiumFlagIcon, 
    BelizeFlagIcon, 
    BeninFlagIcon, 
    BermudaFlagIcon, 
    BhutanFlagIcon, 
    BoliviaFlagIcon, 
    BosniaAndHerzegovinaFlagIcon, 
    BotswanaFlagIcon, 
    BrazilFlagIcon, 
    BruneiFlagIcon, 
    BulgariaFlagIcon, 
    BurkinaFasoFlagIcon, 
    CanadaFlagIcon, 
    CentralAfricanRepublicFlagIcon, 
    NetherlandsAntillesFlagIcon, 
    UkraineFlagIcon, 
    RepublicOfTheCongoFlagIcon, 
    UnitedArabEmiratesFlagIcon, 
    SwitzerlandFlagIcon,
    ChileFlagIcon,
    ChinaFlagIcon,
    IvoryCoastFlagIcon,
    CameroonFlagIcon,
    DRCongoFlagIcon,
    ColombiaFlagIcon,
    ComorosFlagIcon,
    CapeVerdeFlagIcon,
    CostaRicaFlagIcon,
    CubaFlagIcon,
    CyprusFlagIcon,
    CzechiaFlagIcon,
    DenmarkFlagIcon,
    DjiboutiFlagIcon,
    DominicaFlagIcon,
    DominicanRepublicFlagIcon,
    AlgeriaFlagIcon,
    UnitedKingdomFlagIcon,
    TurkeyFlagIcon,
    GeorgiaFlagIcon,
    RussiaFlagIcon,
    GermanyFlagIcon,
    EcuadorFlagIcon,
    EgyptFlagIcon,
    EritreaFlagIcon,
    ElSalvadorFlagIcon,
    SpainFlagIcon,
    EstoniaFlagIcon,
    EthiopiaFlagIcon,
    FinlandFlagIcon,
    FranceFlagIcon,
    MicronesiaFlagIcon,
    FijiFlagIcon,
    FalklandIslandsFlagIcon,
    GabonFlagIcon,
    GambiaFlagIcon,
    GuineaBissauFlagIcon,
    EquatorialGuineaFlagIcon,
    GhanaFlagIcon,
    GreeceFlagIcon,
    GuatemalaFlagIcon,
    GuineaFlagIcon,
    GrenadaFlagIcon,
    GuyanaFlagIcon,
    GuernseyFlagIcon,
    GibraltarFlagIcon,
    HaitiFlagIcon,
    HongKongFlagIcon,
    HondurasFlagIcon,
    HungaryFlagIcon,
    CroatiaFlagIcon,
    IndonesiaFlagIcon,
    IndiaFlagIcon,
    IranFlagIcon,
    IrelandFlagIcon,
    IraqFlagIcon,
    IcelandFlagIcon,
    IsraelFlagIcon,
    ItalyFlagIcon,
    IsleOfManFlagIcon,
    JamaicaFlagIcon,
    JordanFlagIcon,
    JapanFlagIcon,
    JerseyFlagIcon,
    KazakhstanFlagIcon,
    KenyaFlagIcon,
    KyrgyzstanFlagIcon,
    SouthKoreaFlagIcon,
    SaudiArabiaFlagIcon,
    KuwaitFlagIcon,
    CambodiaFlagIcon,
    NorthKoreaFlagIcon,
    SaintKittsAndNevisFlagIcon,
    CaymanIslandsFlagIcon,
    LaosFlagIcon,
    LatviaFlagIcon,
    LibyaFlagIcon,
    LiberiaFlagIcon,
    SaintLuciaFlagIcon,
    LesothoFlagIcon,
    LebanonFlagIcon,
    LiechtensteinFlagIcon,
    LithuaniaFlagIcon,
    LuxembourgFlagIcon,
    SriLankaFlagIcon,
    MadagascarFlagIcon,
    MoroccoFlagIcon,
    MalaysiaFlagIcon,
    MalawiFlagIcon,
    MoldovaFlagIcon,
    MaldivesFlagIcon,
    MexicoFlagIcon,
    MongoliaFlagIcon,
    NorthMacedoniaFlagIcon,
    MaliFlagIcon,
    MaltaFlagIcon,
    MontenegroFlagIcon,
    MonacoFlagIcon,
    MozambiqueFlagIcon,
    MauritiusFlagIcon,
    MauritaniaFlagIcon,
    MyanmarFlagIcon,
    MacauFlagIcon,
    MontserratFlagIcon,
    NamibiaFlagIcon,
    NetherlandsFlagIcon,
    NigeriaFlagIcon,
    NigerFlagIcon,
    NorwayFlagIcon,
    NepalFlagIcon,
    NewZealandFlagIcon,
    NicaraguaFlagIcon,
    OmanFlagIcon,
    PakistanFlagIcon,
    PanamaFlagIcon,
    ParaguayFlagIcon,
    PeruFlagIcon,
    PhilippinesFlagIcon,
    PalauFlagIcon,
    PapuaNewGuineaFlagIcon,
    PolandFlagIcon,
    PortugalFlagIcon,
    PuertoRicoFlagIcon,
    FrenchPolynesiaFlagIcon,
    QatarFlagIcon,
    RomaniaFlagIcon,
    RwandaFlagIcon,
    SerbiaFlagIcon,
    SenegalFlagIcon,
    SingaporeFlagIcon,
    SierraLeoneFlagIcon,
    SloveniaFlagIcon,
    SanMarinoFlagIcon,
    SomaliaFlagIcon,
    SaoTomeAndPrincipeFlagIcon,
    SudanFlagIcon,
    SurinameFlagIcon,
    SlovakiaFlagIcon,
    SwedenFlagIcon,
    SyriaFlagIcon,
    SolomonIslandsFlagIcon,
    SeychellesFlagIcon,
    EswatiniFlagIcon,
    SaintHelenaFlagIcon,
    TanzaniaFlagIcon,
    TongaFlagIcon,
    ThailandFlagIcon,
    TajikistanFlagIcon,
    TimorLesteFlagIcon,
    TogoFlagIcon,
    TrinidadAndTobagoFlagIcon,
    TunisiaFlagIcon,
    TaiwanFlagIcon,
    ChadFlagIcon,
    TurkmenistanFlagIcon,
    TurksAndCaicosIslandsFlagIcon,
    UgandaFlagIcon,
    UruguayFlagIcon,
    UnitedStatesFlagIcon,
    UzbekistanFlagIcon,
    VenezuelaFlagIcon,
    VietnamFlagIcon,
    SamoaFlagIcon,
    SaintVincentAndTheGrenadinesFlagIcon,
    BritishVirginIslandsFlagIcon,
    VanuatuFlagIcon,
    YemenFlagIcon,
    SouthAfricaFlagIcon,
    ZimbabweFlagIcon,
    ZambiaFlagIcon,
    BurundiFlagIcon
} from '@/components/icons/flags';

export type CountryType = {
    name: string;
    shortName: string;
    idd: string;
    flag: () => ReactNode;
}

export const countries: CountryType[] = [
    {
        name: "Afghanistan",
        shortName: "AF",
        idd: "+93",
        flag: () => <AfghanistanFlagIcon />
    },
    {
        name: "Aland Islands",
        shortName: "AX",
        idd: "+35818",
        flag: () => <AlandIslandsFlagIcon />
    },
    {
        name: "Albania",
        shortName: "AL",
        idd: "+355",
        flag: () => <AlbaniaFlagIcon />
    },
    {
        name: "Algeria",
        shortName: "DZ",
        idd: "+213",
        flag: () => <AlgeriaFlagIcon />
    },
    {
        name: "Andorra",
        shortName: "AD",
        idd: "+376",
        flag: () => <AndorraFlagIcon />
    },
    {
        name: "Angola",
        shortName: "AO",
        idd: "+244",
        flag: () => <AngolaFlagIcon />
    },
    {
        name: "Anguilla",
        shortName: "AI",
        idd: "+1264",
        flag: () => <AnguillaFlagIcon />
    },
    {
        name: "Antigua and Barbuda",
        shortName: "AG",
        idd: "+1268",
        flag: () => <AntiguaAndBarbudaFlagIcon />
    },
    {
        name: "Argentina",
        shortName: "AR",
        idd: "+54",
        flag: () => <ArgentinaFlagIcon />
    },
    {
        name: "Armenia",
        shortName: "AM",
        idd: "+374",
        flag: () => <ArmeniaFlagIcon />
    },
    {
        name: "Aruba",
        shortName: "AW",
        idd: "+297",
        flag: () => <ArubaFlagIcon />
    },
    {
        name: "Australia",
        shortName: "AU",
        idd: "+61",
        flag: () => <AustraliaFlagIcon />
    },
    {
        name: "Austria",
        shortName: "AT",
        idd: "+43",
        flag: () => <AustriaFlagIcon />
    },
    {
        name: "Azerbaijan",
        shortName: "AZ",
        idd: "+994",
        flag: () => <AzerbaijanFlagIcon />
    },
    {
        name: "Bahamas",
        shortName: "BS",
        idd: "+1242",
        flag: () => <BahamasFlagIcon />
    },
    {
        name: "Bahrain",
        shortName: "BH",
        idd: "+973",
        flag: () => <BahrainFlagIcon />
    },
    {
        name: "Bangladesh",
        shortName: "BD",
        idd: "+880",
        flag: () => <BangladeshFlagIcon />
    },
    {
        name: "Barbados",
        shortName: "BB",
        idd: "+1246",
        flag: () => <BarbadosFlagIcon />
    },
    {
        name: "Belarus",
        shortName: "BY",
        idd: "+375",
        flag: () => <BelarusFlagIcon />
    },
    {
        name: "Belgium",
        shortName: "BE",
        idd: "+32",
        flag: () => <BelgiumFlagIcon />
    },
    {
        name: "Belize",
        shortName: "BZ",
        idd: "+501",
        flag: () => <BelizeFlagIcon />
    },
    {
        name: "Benin",
        shortName: "BJ",
        idd: "+229",
        flag: () => <BeninFlagIcon />
    },
    {
        name: "Bermuda",
        shortName: "BM",
        idd: "+1441",
        flag: () => <BermudaFlagIcon />
    },
    {
        name: "Bhutan",
        shortName: "BT",
        idd: "+975",
        flag: () => <BhutanFlagIcon />
    },
    {
        name: "Bolivia",
        shortName: "BO",
        idd: "+591",
        flag: () => <BoliviaFlagIcon />
    },
    {
        name: "Bosnia and Herzegovina",
        shortName: "BA",
        idd: "+387",
        flag: () => <BosniaAndHerzegovinaFlagIcon />
    },
    {
        name: "Botswana",
        shortName: "BW",
        idd: "+267",
        flag: () => <BotswanaFlagIcon />
    },
    {
        name: "Brazil",
        shortName: "BR",
        idd: "+55",
        flag: () => <BrazilFlagIcon />
    },
    {
        name: "British Virgin Islands",
        shortName: "VG",
        idd: "+1284",
        flag: () => <BritishVirginIslandsFlagIcon />
    },
    {
        name: "Brunei",
        shortName: "BN",
        idd: "+673",
        flag: () => <BruneiFlagIcon />
    },
    {
        name: "Bulgaria",
        shortName: "BG",
        idd: "+359",
        flag: () => <BulgariaFlagIcon />
    },
    {
        name: "Burkina Faso",
        shortName: "BF",
        idd: "+226",
        flag: () => <BurkinaFasoFlagIcon />
    },
    {
        name: "Burundi",
        shortName: "BI",
        idd: "+257",
        flag: () => <BurundiFlagIcon />
    },
    {
        name: "Cambodia",
        shortName: "KH",
        idd: "+855",
        flag: () => <CambodiaFlagIcon />
    },
    {
        name: "Cameroon",
        shortName: "CM",
        idd: "+237",
        flag: () => <CameroonFlagIcon />
    },
    {
        name: "Canada",
        shortName: "CA",
        idd: "+1",
        flag: () => <CanadaFlagIcon />
    },
    {
        name: "Cape Verde",
        shortName: "CV",
        idd: "+238",
        flag: () => <CapeVerdeFlagIcon />
    },
    {
        name: "Cayman Islands",
        shortName: "KY",
        idd: "+1345",
        flag: () => <CaymanIslandsFlagIcon />
    },
    {
        name: "Central African Republic",
        shortName: "CF",
        idd: "+236",
        flag: () => <CentralAfricanRepublicFlagIcon />
    },
    {
        name: "Chad",
        shortName: "TD",
        idd: "+235",
        flag: () => <ChadFlagIcon />
    },
    {
        name: "Chile",
        shortName: "CL",
        idd: "+56",
        flag: () => <ChileFlagIcon />
    },
    {
        name: "China",
        shortName: "CN",
        idd: "+86",
        flag: () => <ChinaFlagIcon />
    },
    {
        name: "Colombia",
        shortName: "CO",
        idd: "+57",
        flag: () => <ColombiaFlagIcon />
    },
    {
        name: "Comoros",
        shortName: "KM",
        idd: "+269",
        flag: () => <ComorosFlagIcon />
    },
    {
        name: "Costa Rica",
        shortName: "CR",
        idd: "+506",
        flag: () => <CostaRicaFlagIcon />
    },
    {
        name: "Croatia",
        shortName: "HR",
        idd: "+385",
        flag: () => <CroatiaFlagIcon />
    },
    {
        name: "Cuba",
        shortName: "CU",
        idd: "+53",
        flag: () => <CubaFlagIcon />
    },
    {
        name: "Cyprus",
        shortName: "CY",
        idd: "+357",
        flag: () => <CyprusFlagIcon />
    },
    {
        name: "Czechia",
        shortName: "CZ",
        idd: "+420",
        flag: () => <CzechiaFlagIcon />
    },
    {
        name: "Denmark",
        shortName: "DK",
        idd: "+45",
        flag: () => <DenmarkFlagIcon />
    },
    {
        name: "Djibouti",
        shortName: "DJ",
        idd: "+253",
        flag: () => <DjiboutiFlagIcon />
    },
    {
        name: "Dominica",
        shortName: "DM",
        idd: "+1767",
        flag: () => <DominicaFlagIcon />
    },
    {
        name: "Dominican Republic",
        shortName: "DO",
        idd: "+1809,+1829,+1849",
        flag: () => <DominicanRepublicFlagIcon />
    },
    {
        name: "DR Congo",
        shortName: "CD",
        idd: "+243",
        flag: () => <DRCongoFlagIcon />
    },
    {
        name: "Ecuador",
        shortName: "EC",
        idd: "+593",
        flag: () => <EcuadorFlagIcon />
    },
    {
        name: "Egypt",
        shortName: "EG",
        idd: "+20",
        flag: () => <EgyptFlagIcon />
    },
    {
        name: "El Salvador",
        shortName: "SV",
        idd: "+503",
        flag: () => <ElSalvadorFlagIcon />
    },
    {
        name: "Equatorial Guinea",
        shortName: "GQ",
        idd: "+240",
        flag: () => <EquatorialGuineaFlagIcon />
    },
    {
        name: "Eritrea",
        shortName: "ER",
        idd: "+291",
        flag: () => <EritreaFlagIcon />
    },
    {
        name: "Estonia",
        shortName: "EE",
        idd: "+372",
        flag: () => <EstoniaFlagIcon />
    },
    {
        name: "Eswatini",
        shortName: "SZ",
        idd: "+268",
        flag: () => <EswatiniFlagIcon />
    },
    {
        name: "Ethiopia",
        shortName: "ET",
        idd: "+251",
        flag: () => <EthiopiaFlagIcon />
    },
    {
        name: "Falkland Islands",
        shortName: "FK",
        idd: "+500",
        flag: () => <FalklandIslandsFlagIcon />
    },
    {
        name: "Fiji",
        shortName: "FJ",
        idd: "+679",
        flag: () => <FijiFlagIcon />
    },
    {
        name: "Finland",
        shortName: "FI",
        idd: "+358",
        flag: () => <FinlandFlagIcon />
    },
    {
        name: "France",
        shortName: "FR",
        idd: "+33",
        flag: () => <FranceFlagIcon />
    },
    {
        name: "French Polynesia",
        shortName: "PF",
        idd: "+689",
        flag: () => <FrenchPolynesiaFlagIcon />
    },
    {
        name: "Gabon",
        shortName: "GA",
        idd: "+241",
        flag: () => <GabonFlagIcon />
    },
    {
        name: "Gambia",
        shortName: "GM",
        idd: "+220",
        flag: () => <GambiaFlagIcon />
    },
    {
        name: "Georgia",
        shortName: "GE",
        idd: "+995",
        flag: () => <GeorgiaFlagIcon />
    },
    {
        name: "Germany",
        shortName: "DE",
        idd: "+49",
        flag: () => <GermanyFlagIcon />
    },
    {
        name: "Ghana",
        shortName: "GH",
        idd: "+233",
        flag: () => <GhanaFlagIcon />
    },
    {
        name: "Gibraltar",
        shortName: "GI",
        idd: "+350",
        flag: () => <GibraltarFlagIcon />
    },
    {
        name: "Greece",
        shortName: "GR",
        idd: "+30",
        flag: () => <GreeceFlagIcon />
    },
    {
        name: "Grenada",
        shortName: "GD",
        idd: "+1473",
        flag: () => <GrenadaFlagIcon />
    },
    {
        name: "Guatemala",
        shortName: "GT",
        idd: "+502",
        flag: () => <GuatemalaFlagIcon />
    },
    {
        name: "Guernsey",
        shortName: "GG",
        idd: "+44",
        flag: () => <GuernseyFlagIcon />
    },
    {
        name: "Guinea",
        shortName: "GN",
        idd: "+224",
        flag: () => <GuineaFlagIcon />
    },
    {
        name: "Guinea-Bissau",
        shortName: "GW",
        idd: "+245",
        flag: () => <GuineaBissauFlagIcon />
    },
    {
        name: "Guyana",
        shortName: "GY",
        idd: "+592",
        flag: () => <GuyanaFlagIcon />
    },
    {
        name: "Haiti",
        shortName: "HT",
        idd: "+509",
        flag: () => <HaitiFlagIcon />
    },
    {
        name: "Honduras",
        shortName: "HN",
        idd: "+504",
        flag: () => <HondurasFlagIcon />
    },
    {
        name: "Hong Kong",
        shortName: "HK",
        idd: "+852",
        flag: () => <HongKongFlagIcon />
    },
    {
        name: "Hungary",
        shortName: "HU",
        idd: "+36",
        flag: () => <HungaryFlagIcon />
    },
    {
        name: "Iceland",
        shortName: "IS",
        idd: "+354",
        flag: () => <IcelandFlagIcon />
    },
    {
        name: "India",
        shortName: "IN",
        idd: "+91",
        flag: () => <IndiaFlagIcon />
    },
    {
        name: "Indonesia",
        shortName: "ID",
        idd: "+62",
        flag: () => <IndonesiaFlagIcon />
    },
    {
        name: "Iran",
        shortName: "IR",
        idd: "+98",
        flag: () => <IranFlagIcon />
    },
    {
        name: "Iraq",
        shortName: "IQ",
        idd: "+964",
        flag: () => <IraqFlagIcon />
    },
    {
        name: "Ireland",
        shortName: "IE",
        idd: "+353",
        flag: () => <IrelandFlagIcon />
    },
    {
        name: "Isle of Man",
        shortName: "IM",
        idd: "+44",
        flag: () => <IsleOfManFlagIcon />
    },
    {
        name: "Israel",
        shortName: "IL",
        idd: "+972",
        flag: () => <IsraelFlagIcon />
    },
    {
        name: "Italy",
        shortName: "IT",
        idd: "+39",
        flag: () => <ItalyFlagIcon />
    },
    {
        name: "Ivory Coast",
        shortName: "CI",
        idd: "+225",
        flag: () => <IvoryCoastFlagIcon />
    },
    {
        name: "Jamaica",
        shortName: "JM",
        idd: "+1876",
        flag: () => <JamaicaFlagIcon />
    },
    {
        name: "Japan",
        shortName: "JP",
        idd: "+81",
        flag: () => <JapanFlagIcon />
    },
    {
        name: "Jersey",
        shortName: "JE",
        idd: "+44",
        flag: () => <JerseyFlagIcon />
    },
    {
        name: "Jordan",
        shortName: "JO",
        idd: "+962",
        flag: () => <JordanFlagIcon />
    },
    {
        name: "Kazakhstan",
        shortName: "KZ",
        idd: "+76,+77",
        flag: () => <KazakhstanFlagIcon />
    },
    {
        name: "Kenya",
        shortName: "KE",
        idd: "+254",
        flag: () => <KenyaFlagIcon />
    },
    {
        name: "Kuwait",
        shortName: "KW",
        idd: "+965",
        flag: () => <KuwaitFlagIcon />
    },
    {
        name: "Kyrgyzstan",
        shortName: "KG",
        idd: "+996",
        flag: () => <KyrgyzstanFlagIcon />
    },
    {
        name: "Laos",
        shortName: "LA",
        idd: "+856",
        flag: () => <LaosFlagIcon />
    },
    {
        name: "Latvia",
        shortName: "LV",
        idd: "+371",
        flag: () => <LatviaFlagIcon />
    },
    {
        name: "Lebanon",
        shortName: "LB",
        idd: "+961",
        flag: () => <LebanonFlagIcon />
    },
    {
        name: "Lesotho",
        shortName: "LS",
        idd: "+266",
        flag: () => <LesothoFlagIcon />
    },
    {
        name: "Liberia",
        shortName: "LR",
        idd: "+231",
        flag: () => <LiberiaFlagIcon />
    },
    {
        name: "Libya",
        shortName: "LY",
        idd: "+218",
        flag: () => <LibyaFlagIcon />
    },
    {
        name: "Liechtenstein",
        shortName: "LI",
        idd: "+423",
        flag: () => <LiechtensteinFlagIcon />
    },
    {
        name: "Lithuania",
        shortName: "LT",
        idd: "+370",
        flag: () => <LithuaniaFlagIcon />
    },
    {
        name: "Luxembourg",
        shortName: "LU",
        idd: "+352",
        flag: () => <LuxembourgFlagIcon />
    },
    {
        name: "Macau",
        shortName: "MO",
        idd: "+853",
        flag: () => <MacauFlagIcon />
    },
    {
        name: "Madagascar",
        shortName: "MG",
        idd: "+261",
        flag: () => <MadagascarFlagIcon />
    },
    {
        name: "Malawi",
        shortName: "MW",
        idd: "+265",
        flag: () => <MalawiFlagIcon />
    },
    {
        name: "Malaysia",
        shortName: "MY",
        idd: "+60",
        flag: () => <MalaysiaFlagIcon />
    },
    {
        name: "Maldives",
        shortName: "MV",
        idd: "+960",
        flag: () => <MaldivesFlagIcon />
    },
    {
        name: "Mali",
        shortName: "ML",
        idd: "+223",
        flag: () => <MaliFlagIcon />
    },
    {
        name: "Malta",
        shortName: "MT",
        idd: "+356",
        flag: () => <MaltaFlagIcon />
    },
    {
        name: "Mauritania",
        shortName: "MR",
        idd: "+222",
        flag: () => <MauritaniaFlagIcon />
    },
    {
        name: "Mauritius",
        shortName: "MU",
        idd: "+230",
        flag: () => <MauritiusFlagIcon />
    },
    {
        name: "Mexico",
        shortName: "MX",
        idd: "+52",
        flag: () => <MexicoFlagIcon />
    },
    {
        name: "Micronesia",
        shortName: "FM",
        idd: "+691",
        flag: () => <MicronesiaFlagIcon />
    },
    {
        name: "Moldova",
        shortName: "MD",
        idd: "+373",
        flag: () => <MoldovaFlagIcon />
    },
    {
        name: "Monaco",
        shortName: "MC",
        idd: "+377",
        flag: () => <MonacoFlagIcon />
    },
    {
        name: "Mongolia",
        shortName: "MN",
        idd: "+976",
        flag: () => <MongoliaFlagIcon />
    },
    {
        name: "Montenegro",
        shortName: "ME",
        idd: "+382",
        flag: () => <MontenegroFlagIcon />
    },
    {
        name: "Montserrat",
        shortName: "MS",
        idd: "+1664",
        flag: () => <MontserratFlagIcon />
    },
    {
        name: "Morocco",
        shortName: "MA",
        idd: "+212",
        flag: () => <MoroccoFlagIcon />
    },
    {
        name: "Mozambique",
        shortName: "MZ",
        idd: "+258",
        flag: () => <MozambiqueFlagIcon />
    },
    {
        name: "Myanmar",
        shortName: "MM",
        idd: "+95",
        flag: () => <MyanmarFlagIcon />
    },
    {
        name: "Namibia",
        shortName: "NA",
        idd: "+264",
        flag: () => <NamibiaFlagIcon />
    },
    {
        name: "Nepal",
        shortName: "NP",
        idd: "+977",
        flag: () => <NepalFlagIcon />
    },
    {
        name: "Netherlands",
        shortName: "NL",
        idd: "+31",
        flag: () => <NetherlandsFlagIcon />
    },
    {
        name: "Netherlands Antilles",
        shortName: "AN",
        idd: "+599",
        flag: () => <NetherlandsAntillesFlagIcon />
    },
    {
        name: "New Zealand",
        shortName: "NZ",
        idd: "+64",
        flag: () => <NewZealandFlagIcon />
    },
    {
        name: "Nicaragua",
        shortName: "NI",
        idd: "+505",
        flag: () => <NicaraguaFlagIcon />
    },
    {
        name: "Niger",
        shortName: "NE",
        idd: "+227",
        flag: () => <NigerFlagIcon />
    },
    {
        name: "Nigeria",
        shortName: "NG",
        idd: "+234",
        flag: () => <NigeriaFlagIcon />
    },
    {
        name: "North Korea",
        shortName: "KP",
        idd: "+850",
        flag: () => <NorthKoreaFlagIcon />
    },
    {
        name: "North Macedonia",
        shortName: "MK",
        idd: "+389",
        flag: () => <NorthMacedoniaFlagIcon />
    },
    {
        name: "Norway",
        shortName: "NO",
        idd: "+47",
        flag: () => <NorwayFlagIcon />
    },
    {
        name: "Oman",
        shortName: "OM",
        idd: "+968",
        flag: () => <OmanFlagIcon />
    },
    {
        name: "Pakistan",
        shortName: "PK",
        idd: "+92",
        flag: () => <PakistanFlagIcon />
    },
    {
        name: "Palau",
        shortName: "PW",
        idd: "+680",
        flag: () => <PalauFlagIcon />
    },
    {
        name: "Panama",
        shortName: "PA",
        idd: "+507",
        flag: () => <PanamaFlagIcon />
    },
    {
        name: "Papua New Guinea",
        shortName: "PG",
        idd: "+675",
        flag: () => <PapuaNewGuineaFlagIcon />
    },
    {
        name: "Paraguay",
        shortName: "PY",
        idd: "+595",
        flag: () => <ParaguayFlagIcon />
    },
    {
        name: "Peru",
        shortName: "PE",
        idd: "+51",
        flag: () => <PeruFlagIcon />
    },
    {
        name: "Philippines",
        shortName: "PH",
        idd: "+63",
        flag: () => <PhilippinesFlagIcon />
    },
    {
        name: "Poland",
        shortName: "PL",
        idd: "+48",
        flag: () => <PolandFlagIcon />
    },
    {
        name: "Portugal",
        shortName: "PT",
        idd: "+351",
        flag: () => <PortugalFlagIcon />
    },
    {
        name: "Puerto Rico",
        shortName: "PR",
        idd: "+1787,+1939",
        flag: () => <PuertoRicoFlagIcon />
    },
    {
        name: "Qatar",
        shortName: "QA",
        idd: "+974",
        flag: () => <QatarFlagIcon />
    },
    {
        name: "Republic of the Congo",
        shortName: "CG",
        idd: "+242",
        flag: () => <RepublicOfTheCongoFlagIcon />
    },
    {
        name: "Romania",
        shortName: "RO",
        idd: "+40",
        flag: () => <RomaniaFlagIcon />
    },
    {
        name: "Russia",
        shortName: "RU",
        idd: "+73,+74,+75,+78,+79",
        flag: () => <RussiaFlagIcon />
    },
    {
        name: "Rwanda",
        shortName: "RW",
        idd: "+250",
        flag: () => <RwandaFlagIcon />
    },
    {
        name: "Saint Helena, Ascension and Tristan da Cunha",
        shortName: "SH",
        idd: "+290,+247",
        flag: () => <SaintHelenaFlagIcon />
    },
    {
        name: "Saint Kitts and Nevis",
        shortName: "KN",
        idd: "+1869",
        flag: () => <SaintKittsAndNevisFlagIcon />
    },
    {
        name: "Saint Lucia",
        shortName: "LC",
        idd: "+1758",
        flag: () => <SaintLuciaFlagIcon />
    },
    {
        name: "Saint Vincent and the Grenadines",
        shortName: "VC",
        idd: "+1784",
        flag: () => <SaintVincentAndTheGrenadinesFlagIcon />
    },
    {
        name: "Samoa",
        shortName: "WS",
        idd: "+685",
        flag: () => <SamoaFlagIcon />
    },
    {
        name: "San Marino",
        shortName: "SM",
        idd: "+378",
        flag: () => <SanMarinoFlagIcon />
    },
    {
        name: "São Tomé and Príncipe",
        shortName: "ST",
        idd: "+239",
        flag: () => <SaoTomeAndPrincipeFlagIcon />
    },
    {
        name: "Saudi Arabia",
        shortName: "SA",
        idd: "+966",
        flag: () => <SaudiArabiaFlagIcon />
    },
    {
        name: "Senegal",
        shortName: "SN",
        idd: "+221",
        flag: () => <SenegalFlagIcon />
    },
    {
        name: "Serbia",
        shortName: "RS",
        idd: "+381",
        flag: () => <SerbiaFlagIcon />
    },
    {
        name: "Seychelles",
        shortName: "SC",
        idd: "+248",
        flag: () => <SeychellesFlagIcon />
    },
    {
        name: "Sierra Leone",
        shortName: "SL",
        idd: "+232",
        flag: () => <SierraLeoneFlagIcon />
    },
    {
        name: "Singapore",
        shortName: "SG",
        idd: "+65",
        flag: () => <SingaporeFlagIcon />
    },
    {
        name: "Slovakia",
        shortName: "SK",
        idd: "+421",
        flag: () => <SlovakiaFlagIcon />
    },
    {
        name: "Slovenia",
        shortName: "SI",
        idd: "+386",
        flag: () => <SloveniaFlagIcon />
    },
    {
        name: "Solomon Islands",
        shortName: "SB",
        idd: "+677",
        flag: () => <SolomonIslandsFlagIcon />
    },
    {
        name: "Somalia",
        shortName: "SO",
        idd: "+252",
        flag: () => <SomaliaFlagIcon />
    },
    {
        name: "South Africa",
        shortName: "ZA",
        idd: "+27",
        flag: () => <SouthAfricaFlagIcon />
    },
    {
        name: "South Korea",
        shortName: "KR",
        idd: "+82",
        flag: () => <SouthKoreaFlagIcon />
    },
    {
        name: "Spain",
        shortName: "ES",
        idd: "+34",
        flag: () => <SpainFlagIcon />
    },
    {
        name: "Sri Lanka",
        shortName: "LK",
        idd: "+94",
        flag: () => <SriLankaFlagIcon />
    },
    {
        name: "Sudan",
        shortName: "SD",
        idd: "+249",
        flag: () => <SudanFlagIcon />
    },
    {
        name: "Suriname",
        shortName: "SR",
        idd: "+597",
        flag: () => <SurinameFlagIcon />
    },
    {
        name: "Sweden",
        shortName: "SE",
        idd: "+46",
        flag: () => <SwedenFlagIcon />
    },
    {
        name: "Switzerland",
        shortName: "CH",
        idd: "+41",
        flag: () => <SwitzerlandFlagIcon />
    },
    {
        name: "Syria",
        shortName: "SY",
        idd: "+963",
        flag: () => <SyriaFlagIcon />
    },
    {
        name: "Taiwan",
        shortName: "TW",
        idd: "+886",
        flag: () => <TaiwanFlagIcon />
    },
    {
        name: "Tajikistan",
        shortName: "TJ",
        idd: "+992",
        flag: () => <TajikistanFlagIcon />
    },
    {
        name: "Tanzania",
        shortName: "TZ",
        idd: "+255",
        flag: () => <TanzaniaFlagIcon />
    },
    {
        name: "Thailand",
        shortName: "TH",
        idd: "+66",
        flag: () => <ThailandFlagIcon />
    },
    {
        name: "Timor-Leste",
        shortName: "TL",
        idd: "+670",
        flag: () => <TimorLesteFlagIcon />
    },
    {
        name: "Togo",
        shortName: "TG",
        idd: "+228",
        flag: () => <TogoFlagIcon />
    },
    {
        name: "Tonga",
        shortName: "TO",
        idd: "+676",
        flag: () => <TongaFlagIcon />
    },
    {
        name: "Trinidad and Tobago",
        shortName: "TT",
        idd: "+1868",
        flag: () => <TrinidadAndTobagoFlagIcon />
    },
    {
        name: "Tunisia",
        shortName: "TN",
        idd: "+216",
        flag: () => <TunisiaFlagIcon />
    },
    {
        name: "Turkey",
        shortName: "TR",
        idd: "+90",
        flag: () => <TurkeyFlagIcon />
    },
    {
        name: "Turkmenistan",
        shortName: "TM",
        idd: "+993",
        flag: () => <TurkmenistanFlagIcon />
    },
    {
        name: "Turks and Caicos Islands",
        shortName: "TC",
        idd: "+1649",
        flag: () => <TurksAndCaicosIslandsFlagIcon />
    },
    {
        name: "Uganda",
        shortName: "UG",
        idd: "+256",
        flag: () => <UgandaFlagIcon />
    },
    {
        name: "Ukraine",
        shortName: "UA",
        idd: "+380",
        flag: () => <UkraineFlagIcon />
    },
    {
        name: "United Arab Emirates",
        shortName: "AE",
        idd: "+971",
        flag: () => <UnitedArabEmiratesFlagIcon />
    },
    {
        name: "United Kingdom",
        shortName: "GB",
        idd: "+44",
        flag: () => <UnitedKingdomFlagIcon />
    },
    {
        name: "United States",
        shortName: "US",
        idd: "+1201,+1202,+1203,+1205,+1206,+1207,+1208,+1209,+1210,+1212,+1213,+1214,+1215,+1216,+1217,+1218,+1219,+1220,+1224,+1225,+1227,+1228,+1229,+1231,+1234,+1239,+1240,+1248,+1251,+1252,+1253,+1254,+1256,+1260,+1262,+1267,+1269,+1270,+1272,+1274,+1276,+1281,+1283,+1301,+1302,+1303,+1304,+1305,+1307,+1308,+1309,+1310,+1312,+1313,+1314,+1315,+1316,+1317,+1318,+1319,+1320,+1321,+1323,+1325,+1327,+1330,+1331,+1334,+1336,+1337,+1339,+1346,+1347,+1351,+1352,+1360,+1361,+1364,+1380,+1385,+1386,+1401,+1402,+1404,+1405,+1406,+1407,+1408,+1409,+1410,+1412,+1413,+1414,+1415,+1417,+1419,+1423,+1424,+1425,+1430,+1432,+1434,+1435,+1440,+1442,+1443,+1447,+1458,+1463,+1464,+1469,+1470,+1475,+1478,+1479,+1480,+1484,+1501,+1502,+1503,+1504,+1505,+1507,+1508,+1509,+1510,+1512,+1513,+1515,+1516,+1517,+1518,+1520,+1530,+1531,+1534,+1539,+1540,+1541,+1551,+1559,+1561,+1562,+1563,+1564,+1567,+1570,+1571,+1573,+1574,+1575,+1580,+1585,+1586,+1601,+1602,+1603,+1605,+1606,+1607,+1608,+1609,+1610,+1612,+1614,+1615,+1616,+1617,+1618,+1619,+1620,+1623,+1626,+1628,+1629,+1630,+1631,+1636,+1641,+1646,+1650,+1651,+1657,+1660,+1661,+1662,+1667,+1669,+1678,+1681,+1682,+1701,+1702,+1703,+1704,+1706,+1707,+1708,+1712,+1713,+1714,+1715,+1716,+1717,+1718,+1719,+1720,+1724,+1725,+1727,+1730,+1731,+1732,+1734,+1737,+1740,+1743,+1747,+1754,+1757,+1760,+1762,+1763,+1765,+1769,+1770,+1772,+1773,+1774,+1775,+1779,+1781,+1785,+1786,+1801,+1802,+1803,+1804,+1805,+1806,+1808,+1810,+1812,+1813,+1814,+1815,+1816,+1817,+1818,+1828,+1830,+1831,+1832,+1843,+1845,+1847,+1848,+1850,+1854,+1856,+1857,+1858,+1859,+1860,+1862,+1863,+1864,+1865,+1870,+1872,+1878,+1901,+1903,+1904,+1906,+1907,+1908,+1909,+1910,+1912,+1913,+1914,+1915,+1916,+1917,+1918,+1919,+1920,+1925,+1928,+1929,+1930,+1931,+1934,+1936,+1937,+1938,+1940,+1941,+1947,+1949,+1951,+1952,+1954,+1956,+1959,+1970,+1971,+1972,+1973,+1975,+1978,+1979,+1980,+1984,+1985,+1989",
        flag: () => <UnitedStatesFlagIcon />
    },
    {
        name: "Uruguay",
        shortName: "UY",
        idd: "+598",
        flag: () => <UruguayFlagIcon />
    },
    {
        name: "Uzbekistan",
        shortName: "UZ",
        idd: "+998",
        flag: () => <UzbekistanFlagIcon />
    },
    {
        name: "Vanuatu",
        shortName: "VU",
        idd: "+678",
        flag: () => <VanuatuFlagIcon />
    },
    {
        name: "Venezuela",
        shortName: "VE",
        idd: "+58",
        flag: () => <VenezuelaFlagIcon />
    },
    {
        name: "Vietnam",
        shortName: "VN",
        idd: "+84",
        flag: () => <VietnamFlagIcon />
    },
    {
        name: "Yemen",
        shortName: "YE",
        idd: "+967",
        flag: () => <YemenFlagIcon />
    },
    {
        name: "Zambia",
        shortName: "ZM",
        idd: "+260",
        flag: () => <ZambiaFlagIcon />
    },
    {
        name: "Zimbabwe",
        shortName: "ZW",
        idd: "+263",
        flag: () => <ZimbabweFlagIcon />
    }
];